import gql from "graphql-tag";

export const ConfigQuery = gql`
  query orderaheadAdminConfig {
    config {
      __typename
      consumerAndroidForceVersion
      consumerAndroidLatestVersion
      consumerIosForceVersion
      consumerIosLatestVersion
      merchantAmazonForceVersion
      merchantAmazonLatestVersion
      merchantAndroidForceVersion
      merchantAndroidLatestVersion
      merchantIosForceVersion
      merchantIosLatestVersion
      merchantTabletUpgradeMessage
      merchantTabletUpgradeStartDate
      edition
      id
      createdAt
    }
  }
`

export const ConfigsQuery = gql`
  query orderaheadAdminConfigs($pageSize: Int, $cursor: String, $orderBy: ConfigOrderBy) {
    configs(first: $pageSize, after: $cursor, orderBy: $orderBy) {
      __typename
      edges {
        node {
          consumerAndroidForceVersion
          consumerAndroidLatestVersion
          consumerIosForceVersion
          consumerIosLatestVersion
          merchantAmazonForceVersion
          merchantAmazonLatestVersion
          merchantAndroidForceVersion
          merchantAndroidLatestVersion
          merchantIosForceVersion
          merchantIosLatestVersion
          merchantTabletUpgradeMessage
          merchantTabletUpgradeStartDate
          edition
          id
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

export const UpdateConfigMutation = gql`
  mutation orderaheadAdminUpdateConfig($updateConfigInput: UpdateConfigInput!) {
    updateConfig(input: $updateConfigInput) {
      __typename
      currentEdition
      configResult {
        ... on ConfigSuccess {
          __typename
          config {
            consumerAndroidForceVersion
            consumerAndroidLatestVersion
            consumerIosForceVersion
            consumerIosLatestVersion
            merchantAmazonForceVersion
            merchantAmazonLatestVersion
            merchantAndroidForceVersion
            merchantAndroidLatestVersion
            merchantIosForceVersion
            merchantIosLatestVersion
            merchantTabletUpgradeMessage
            merchantTabletUpgradeStartDate
            edition
            id
            createdAt
          }
        }
        ... on StaleConfigError {
          __typename
        }
        ... on InvalidConfigError {
          __typename
          errors {
            message
            path
          }
        }
      }
    }
  }
`
export const BatchedDepositsQuery = gql`
  query orderaheadAdminBatchedDeposits(
    $pageSize: Int,
    $cursor: String,
    $forDateRange: DateRangeInput,
    $totalCentsRange: IntRangeInput,
    $orderBy: BatchedDepositOrderBy
  ) {
    batchedDeposits(
      first: $pageSize,
      after: $cursor,
      forDateRange: $forDateRange,
      totalCentsRange: $totalCentsRange,
      orderBy: $orderBy
    ) {
      __typename
      edges {
        node {
          id
          earnedSubtotalCents
          earnedSubtotalCurrency
          externalMemo
          for
          lastKnownTransactionStatus
          merchant {
            id
            name
            streetAddress
          }
          outstandingCents
          outstandingCurrency
          period
          submittedAt
          totalCents
          totalCurrency
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

export const BatchedDepositQuery = gql`
  query orderaheadAdminBatchedDeposit($nodeId: ID!) {
    node(id: $nodeId) {
      __typename
      id
      ... on BatchedDeposit {
        earnedSubtotalCents
        earnedSubtotalCurrency
        externalMemo
        for
        lastKnownTransactionStatus
        lastKnownTransactionId
        merchant {
          id
          name
          streetAddress
        }
        outstandingCents
        outstandingCurrency
        period
        submittedAt
        totalCents
        totalCurrency
      }
    }
  }
`

export const AllowanceRecipientsQuery = gql`
  query orderaheadAdminAllowanceRecipients(
    $pageSize: Int,
    $cursor: String,
    $orderBy: AllowanceRecipientOrderBy
  ) {
    allowanceRecipients(
      first: $pageSize,
      after: $cursor,
      orderBy: $orderBy
    ) {
      __typename
      edges {
        node {
          id
          email
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`
